export const KnowledgeData = [
    {
        skill: 'HTML5',
        link: 'https://developer.mozilla.org/en-US/docs/Web/HTML',
        cName: 'html knowledge'
    },
    {
        skill: 'CSS3',
        link: 'https://developer.mozilla.org/en-US/docs/Web/CSS',
        cName: 'css knowledge'
    },
    {
        skill: 'JavaScript',
        link: 'https://developer.mozilla.org/en-US/docs/Web/javascript',
        cName: 'javascript knowledge'
    },
    {
        skill: 'Node.js',
        link: 'https://developer.mozilla.org/en-US/docs/Glossary/Node.js',
        cName: 'node knowledge'
    },
    {
        skill: 'Express',
        link: 'https://expressjs.com/',
        cName: 'express knowledge'
    },
    {
        skill: 'React',
        link: 'https://reactjs.org/',
        cName: 'react knowledge'
    },
    {
        skill: 'Pug',
        link: 'https://pugjs.org/api/getting-started.html',
        cName: 'pug knowledge'
    },
    {
        skill: 'RestAPI',
        link: 'https://restfulapi.net/',
        cName: 'rest knowledge'
    },
    {
        skill: 'SQL',
        link: 'https://en.wikipedia.org/wiki/SQL',
        cName: 'sql knowledge'
    }
]